import React from 'react';

export type BadgeVariant = 
  | 'active' 
  | 'locked' 
  | 'ACTIVE' 
  | 'INACTIVE' 
  | 'TRIAL_REGISTERED' 
  | 'TRIAL_UNREGISTERED' 
  | 'ERROR' 
  | 'ARCHIVED' 
  | 'PROVISION' 
  | 'SUBSCRIBED' 
  | 'MIGRATION'
  | 'US'
  | 'EU' 
  | 'UK'
  | 'APAC'
  | 'UNKNOWN'
  | string;

const STATUS_COLOR_MAP: Record<string, string> = {
  'active': 'access-eaglegreen',
  'locked': 'access-accessred',
  'ACTIVE': 'access-eaglegreen',
  'INACTIVE': 'access-accessred',
  'TRIAL_REGISTERED': 'access-neutral',
  'TRIAL_UNREGISTERED': 'access-burntorange',
  'ERROR': 'access-accessred',
  'ARCHIVED': 'access-neutral',
  'PROVISION': 'access-bluelagoon',
  'SUBSCRIBED': 'access-sapgreen',
  'MIGRATION': 'access-electricviolet',
  'US': 'access-bluelagoon',
  'EU': 'access-sapgreen',
  'UK': 'access-ceruleanblue',
  'APAC': 'access-burntorange',
  'UNKNOWN': 'access-neutral',
};

interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

export function Badge({ variant, children, className = '' }: BadgeProps) {
  const colorClass = STATUS_COLOR_MAP[variant] || 'access-neutral';
  
  return (
    <span className={`access-badge ${colorClass} ${className}`}>
      {children}
    </span>
  );
}
